@file:OptIn(InternalResourceApi::class)

package com.xtream.sharedResources.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.xtream.sharedResources.resources/"

@delegate:ResourceContentHash(119_606_014)
public val Res.string.reorder_tv_channels: StringResource by lazy {
      StringResource("string:reorder_tv_channels", "reorder_tv_channels", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4383, 63),
      ))
    }

@delegate:ResourceContentHash(-62_739_320)
public val Res.string.repeat_toggle: StringResource by lazy {
      StringResource("string:repeat_toggle", "repeat_toggle", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5687, 57),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6463, 73),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4687, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4447, 41),
      ))
    }

@delegate:ResourceContentHash(-126_727_122)
public val Res.string.resume_last_playback_desc: StringResource by lazy {
      StringResource("string:resume_last_playback_desc", "resume_last_playback_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5745, 141),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6537, 169),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4741, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4489, 105),
      ))
    }

@delegate:ResourceContentHash(2_061_854_505)
public val Res.string.resume_last_played_activity: StringResource by lazy {
      StringResource("string:resume_last_played_activity", "resume_last_played_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5887, 91),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6707, 123),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4839, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4595, 71),
      ))
    }

@delegate:ResourceContentHash(1_846_993_839)
public val Res.string.retry: StringResource by lazy {
      StringResource("string:retry", "retry", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5979, 49),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6831, 53),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4915, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4667, 21),
      ))
    }

@delegate:ResourceContentHash(1_066_725_256)
public val Res.string.rewind: StringResource by lazy {
      StringResource("string:rewind", "rewind", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6029, 30),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6885, 42),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4953, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4689, 22),
      ))
    }

@delegate:ResourceContentHash(-1_688_909_646)
public val Res.string.rotate: StringResource by lazy {
      StringResource("string:rotate", "rotate", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6060, 30),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6928, 30),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4988, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4712, 22),
      ))
    }

@delegate:ResourceContentHash(-550_710_348)
public val Res.string.scan_me: StringResource by lazy {
      StringResource("string:scan_me", "scan_me", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6091, 31),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6959, 31),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5015, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4735, 27),
      ))
    }

@delegate:ResourceContentHash(1_746_989_423)
public val Res.string.search: StringResource by lazy {
      StringResource("string:search", "search", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6314, 22),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7182, 30),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5202, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4870, 22),
      ))
    }

@delegate:ResourceContentHash(710_164_366)
public val Res.string.search_hint: StringResource by lazy {
      StringResource("string:search_hint", "search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6123, 127),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6991, 143),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5047, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4763, 71),
      ))
    }

@delegate:ResourceContentHash(419_482_213)
public val Res.string.search_tab: StringResource by lazy {
      StringResource("string:search_tab", "search_tab", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6251, 62),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7135, 46),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5155, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4835, 34),
      ))
    }

@delegate:ResourceContentHash(-1_857_041_270)
public val Res.string.season: StringResource by lazy {
      StringResource("string:season", "season", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6373, 26),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7253, 26),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5253, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4921, 22),
      ))
    }

@delegate:ResourceContentHash(-1_057_842_530)
public val Res.string.seasons: StringResource by lazy {
      StringResource("string:seasons", "seasons", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6337, 35),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7213, 39),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5229, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4893, 27),
      ))
    }

@delegate:ResourceContentHash(992_949_825)
public val Res.string.series: StringResource by lazy {
      StringResource("string:series", "series", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6475, 38),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7335, 38),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5319, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4979, 22),
      ))
    }

@delegate:ResourceContentHash(1_538_149_450)
public val Res.string.series_tab: StringResource by lazy {
      StringResource("string:series_tab", "series_tab", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6400, 74),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7280, 54),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5276, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4944, 34),
      ))
    }

@delegate:ResourceContentHash(-395_641_048)
public val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6514, 40),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7374, 48),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5350, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5002, 28),
      ))
    }

@delegate:ResourceContentHash(-1_309_324_362)
public val Res.string.show_and_hide_categoires: StringResource by lazy {
      StringResource("string:show_and_hide_categoires", "show_and_hide_categoires", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5031, 60),
      ))
    }

@delegate:ResourceContentHash(-368_287_086)
public val Res.string.shuffle: StringResource by lazy {
      StringResource("string:shuffle", "shuffle", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6555, 47),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7423, 39),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5383, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5092, 27),
      ))
    }

@delegate:ResourceContentHash(1_597_908_565)
public val Res.string.sponsored: StringResource by lazy {
      StringResource("string:sponsored", "sponsored", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6603, 33),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7463, 49),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5423, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5120, 29),
      ))
    }

@delegate:ResourceContentHash(-1_270_674_451)
public val Res.string.stream_format: StringResource by lazy {
      StringResource("string:stream_format", "stream_format", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6637, 45),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7513, 69),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5461, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5150, 41),
      ))
    }

@delegate:ResourceContentHash(2_061_034_497)
public val Res.string.subtitle_tracks: StringResource by lazy {
      StringResource("string:subtitle_tracks", "subtitle_tracks", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6683, 43),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7583, 43),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5503, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5192, 43),
      ))
    }

@delegate:ResourceContentHash(1_955_108_123)
public val Res.string.support_1: StringResource by lazy {
      StringResource("string:support_1", "support_1", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6727, 29),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7627, 41),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5543, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5236, 29),
      ))
    }

@delegate:ResourceContentHash(1_958_921_403)
public val Res.string.support_2: StringResource by lazy {
      StringResource("string:support_2", "support_2", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6757, 29),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7669, 41),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5577, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5266, 29),
      ))
    }

@delegate:ResourceContentHash(1_459_419_873)
public val Res.string.support_contact: StringResource by lazy {
      StringResource("string:support_contact", "support_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6787, 43),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7711, 47),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5611, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5296, 43),
      ))
    }

@delegate:ResourceContentHash(1_755_429_200)
public val Res.string.telegram: StringResource by lazy {
      StringResource("string:telegram", "telegram", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6831, 40),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7759, 40),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5647, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5340, 28),
      ))
    }

@delegate:ResourceContentHash(-1_269_289_217)
public val Res.string.theme: StringResource by lazy {
      StringResource("string:theme", "theme", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6872, 29),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7800, 29),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5676, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5369, 21),
      ))
    }

@delegate:ResourceContentHash(-85_552_567)
public val Res.string.this_may_take_a_while: StringResource by lazy {
      StringResource("string:this_may_take_a_while", "this_may_take_a_while", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6902, 89),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7830, 101),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5698, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5391, 61),
      ))
    }

@delegate:ResourceContentHash(1_222_620_414)
public val Res.string.toolbar_fragment: StringResource by lazy {
      StringResource("string:toolbar_fragment", "toolbar_fragment", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 6992, 64),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7932, 64),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5776, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5453, 48),
      ))
    }

@delegate:ResourceContentHash(-1_396_605_596)
public val Res.string.top_rated_movies: StringResource by lazy {
      StringResource("string:top_rated_movies", "top_rated_movies", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7057, 76),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 7997, 92),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5821, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5502, 48),
      ))
    }

@delegate:ResourceContentHash(-1_967_917_193)
public val Res.string.trailer: StringResource by lazy {
      StringResource("string:trailer", "trailer", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7134, 31),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8090, 39),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5890, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5551, 27),
      ))
    }

@delegate:ResourceContentHash(2_090_442_960)
public val Res.string.trending: StringResource by lazy {
      StringResource("string:trending", "trending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5673, 28),
      ))
    }

@delegate:ResourceContentHash(1_588_002_947)
public val Res.string.trending_movies: StringResource by lazy {
      StringResource("string:trending_movies", "trending_movies", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7166, 51),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8130, 63),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5918, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5579, 43),
      ))
    }

@delegate:ResourceContentHash(1_953_051_372)
public val Res.string.trending_tv_shows: StringResource by lazy {
      StringResource("string:trending_tv_shows", "trending_tv_shows", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7218, 61),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8194, 81),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 5962, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5623, 49),
      ))
    }

@delegate:ResourceContentHash(292_516_141)
public val Res.string.trial_badge: StringResource by lazy {
      StringResource("string:trial_badge", "trial_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7280, 51),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8276, 67),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6016, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5702, 35),
      ))
    }

@delegate:ResourceContentHash(-429_535_772)
public val Res.string.trial_warning: StringResource by lazy {
      StringResource("string:trial_warning", "trial_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7332, 225),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8344, 237),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6064, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5738, 141),
      ))
    }

@delegate:ResourceContentHash(-411_352_654)
public val Res.string.tv_channels: StringResource by lazy {
      StringResource("string:tv_channels", "tv_channels", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7558, 59),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8582, 79),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6214, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5880, 35),
      ))
    }

@delegate:ResourceContentHash(2_042_258_445)
public val Res.string.tv_shows: StringResource by lazy {
      StringResource("string:tv_shows", "tv_shows", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7618, 72),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8662, 76),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6250, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5916, 28),
      ))
    }

@delegate:ResourceContentHash(-1_828_834_860)
public val Res.string.up_arrow: StringResource by lazy {
      StringResource("string:up_arrow", "up_arrow", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7691, 40),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8739, 44),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6291, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5945, 28),
      ))
    }

@delegate:ResourceContentHash(1_394_739_555)
public val Res.string.use_acc: StringResource by lazy {
      StringResource("string:use_acc", "use_acc", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7835, 47),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8915, 63),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6419, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6057, 39),
      ))
    }

@delegate:ResourceContentHash(316_574_449)
public val Res.string.use_acc_or_activation_code: StringResource by lazy {
      StringResource("string:use_acc_or_activation_code", "use_acc_or_activation_code", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7732, 102),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8784, 130),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6324, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5974, 82),
      ))
    }

@delegate:ResourceContentHash(2_055_705_356)
public val Res.string.use_activation_code: StringResource by lazy {
      StringResource("string:use_activation_code", "use_activation_code", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7883, 75),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 8979, 95),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6467, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6097, 55),
      ))
    }

@delegate:ResourceContentHash(1_012_776_731)
public val Res.string.user_data: StringResource by lazy {
      StringResource("string:user_data", "user_data", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 7959, 57),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9075, 69),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6535, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6153, 29),
      ))
    }

@delegate:ResourceContentHash(1_942_614_509)
public val Res.string.user_login_text_error: StringResource by lazy {
      StringResource("string:user_login_text_error", "user_login_text_error", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8017, 89),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9145, 81),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6581, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6183, 57),
      ))
    }

@delegate:ResourceContentHash(1_313_042_994)
public val Res.string.username_and_pass: StringResource by lazy {
      StringResource("string:username_and_pass", "username_and_pass", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8107, 89),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9227, 93),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6635, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6241, 49),
      ))
    }

@delegate:ResourceContentHash(1_224_086_990)
public val Res.string.username_text: StringResource by lazy {
      StringResource("string:username_text", "username_text", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8197, 53),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9321, 61),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6697, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6291, 33),
      ))
    }

@delegate:ResourceContentHash(216_610_312)
public val Res.string.using_cached_data: StringResource by lazy {
      StringResource("string:using_cached_data", "using_cached_data", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8251, 117),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9383, 105),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6743, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6325, 61),
      ))
    }

@delegate:ResourceContentHash(478_611_319)
public val Res.string.vertical_gridview: StringResource by lazy {
      StringResource("string:vertical_gridview", "vertical_gridview", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8369, 61),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9489, 81),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6825, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6387, 49),
      ))
    }

@delegate:ResourceContentHash(-520_657_207)
public val Res.string.video_play_pause: StringResource by lazy {
      StringResource("string:video_play_pause", "video_play_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8431, 76),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9571, 88),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6883, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6437, 48),
      ))
    }

@delegate:ResourceContentHash(1_372_475_475)
public val Res.string.video_player_progress_bar: StringResource by lazy {
      StringResource("string:video_player_progress_bar", "video_player_progress_bar", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8508, 89),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9660, 93),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 6952, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6486, 69),
      ))
    }

@delegate:ResourceContentHash(2_004_688_788)
public val Res.string.video_render_mode: StringResource by lazy {
      StringResource("string:video_render_mode", "video_render_mode", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8598, 65),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9754, 85),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 7026, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6556, 49),
      ))
    }

@delegate:ResourceContentHash(-272_513_165)
public val Res.string.video_resize: StringResource by lazy {
      StringResource("string:video_resize", "video_resize", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8664, 64),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9840, 72),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 7092, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6606, 36),
      ))
    }

@delegate:ResourceContentHash(-1_194_411_807)
public val Res.string.video_scaling_mode: StringResource by lazy {
      StringResource("string:video_scaling_mode", "video_scaling_mode", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8729, 70),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 9913, 90),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 7153, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6643, 50),
      ))
    }

@delegate:ResourceContentHash(-1_018_232_986)
public val Res.string.video_traks: StringResource by lazy {
      StringResource("string:video_traks", "video_traks", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8800, 55),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 10004, 59),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 7216, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6694, 35),
      ))
    }

@delegate:ResourceContentHash(-723_227_925)
public val Res.string.view_all: StringResource by lazy {
      StringResource("string:view_all", "view_all", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8856, 36),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 10064, 52),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 7260, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6730, 28),
      ))
    }

@delegate:ResourceContentHash(-1_061_097_344)
public val Res.string.virtual_reality: StringResource by lazy {
      StringResource("string:virtual_reality", "virtual_reality", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8893, 67),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 10117, 67),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 7297, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6759, 43),
      ))
    }

@delegate:ResourceContentHash(892_812_601)
public val Res.string.website: StringResource by lazy {
      StringResource("string:website", "website", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 8961, 51),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 10185, 51),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 7341, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6803, 35),
      ))
    }

@delegate:ResourceContentHash(-1_688_898_885)
public val Res.string.yes: StringResource by lazy {
      StringResource("string:yes", "yes", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 9013, 19),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 10237, 23),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 7377, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6839, 15),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("reorder_tv_channels", Res.string.reorder_tv_channels)
  map.put("repeat_toggle", Res.string.repeat_toggle)
  map.put("resume_last_playback_desc", Res.string.resume_last_playback_desc)
  map.put("resume_last_played_activity", Res.string.resume_last_played_activity)
  map.put("retry", Res.string.retry)
  map.put("rewind", Res.string.rewind)
  map.put("rotate", Res.string.rotate)
  map.put("scan_me", Res.string.scan_me)
  map.put("search", Res.string.search)
  map.put("search_hint", Res.string.search_hint)
  map.put("search_tab", Res.string.search_tab)
  map.put("season", Res.string.season)
  map.put("seasons", Res.string.seasons)
  map.put("series", Res.string.series)
  map.put("series_tab", Res.string.series_tab)
  map.put("settings", Res.string.settings)
  map.put("show_and_hide_categoires", Res.string.show_and_hide_categoires)
  map.put("shuffle", Res.string.shuffle)
  map.put("sponsored", Res.string.sponsored)
  map.put("stream_format", Res.string.stream_format)
  map.put("subtitle_tracks", Res.string.subtitle_tracks)
  map.put("support_1", Res.string.support_1)
  map.put("support_2", Res.string.support_2)
  map.put("support_contact", Res.string.support_contact)
  map.put("telegram", Res.string.telegram)
  map.put("theme", Res.string.theme)
  map.put("this_may_take_a_while", Res.string.this_may_take_a_while)
  map.put("toolbar_fragment", Res.string.toolbar_fragment)
  map.put("top_rated_movies", Res.string.top_rated_movies)
  map.put("trailer", Res.string.trailer)
  map.put("trending", Res.string.trending)
  map.put("trending_movies", Res.string.trending_movies)
  map.put("trending_tv_shows", Res.string.trending_tv_shows)
  map.put("trial_badge", Res.string.trial_badge)
  map.put("trial_warning", Res.string.trial_warning)
  map.put("tv_channels", Res.string.tv_channels)
  map.put("tv_shows", Res.string.tv_shows)
  map.put("up_arrow", Res.string.up_arrow)
  map.put("use_acc", Res.string.use_acc)
  map.put("use_acc_or_activation_code", Res.string.use_acc_or_activation_code)
  map.put("use_activation_code", Res.string.use_activation_code)
  map.put("user_data", Res.string.user_data)
  map.put("user_login_text_error", Res.string.user_login_text_error)
  map.put("username_and_pass", Res.string.username_and_pass)
  map.put("username_text", Res.string.username_text)
  map.put("using_cached_data", Res.string.using_cached_data)
  map.put("vertical_gridview", Res.string.vertical_gridview)
  map.put("video_play_pause", Res.string.video_play_pause)
  map.put("video_player_progress_bar", Res.string.video_player_progress_bar)
  map.put("video_render_mode", Res.string.video_render_mode)
  map.put("video_resize", Res.string.video_resize)
  map.put("video_scaling_mode", Res.string.video_scaling_mode)
  map.put("video_traks", Res.string.video_traks)
  map.put("view_all", Res.string.view_all)
  map.put("virtual_reality", Res.string.virtual_reality)
  map.put("website", Res.string.website)
  map.put("yes", Res.string.yes)
}
